import { gql } from '@apollo/client';
import CommonFragments from 'features/common/fragments';
import {
  leasingIncomeSchemaDetailFragment,
  leasingIncomeSchemaFragment,
  leasingIncomeSchemaXPartnerFragment,
  leasingIncomeSchemaPropertyFragment,
  leasingIncomeSchemaXGroupFragment
} from './fragments';

export const LEASING_INCOME_SCHEMA_SAVED = gql`
  subscription leasingIncomeSchemaSaved {
    leasingIncomeSchemaSaved {
      leasingIncomeSchema {
        ...leasingIncomeSchema
      }
      silent
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
  ${leasingIncomeSchemaFragment}
`;

export const LEASING_INCOME_SCHEMA_STATE_UPDATED = gql`
  subscription leasingIncomeSchemaStateUpdated($id: Int!) {
    leasingIncomeSchemaStateUpdated(id: $id) {
      leasingIncomeSchema {
        ...leasingIncomeSchema
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
  ${leasingIncomeSchemaFragment}
`;

export const LEASING_INCOME_SCHEMA_DETAILS_SAVED = gql`
  subscription leasingIncomeSchemaDetailsSaved {
    leasingIncomeSchemaDetailsSaved {
      details {
        ...leasingIncomeSchemaDetail
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
  ${leasingIncomeSchemaDetailFragment}
`;

export const LEASING_INCOME_SCHEMA_PROPERTIES_SAVED = gql`
  subscription leasingIncomeSchemaPropertiesSaved {
    leasingIncomeSchemaPropertiesSaved {
      properties {
        ...leasingIncomeSchemaProperty
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
  ${leasingIncomeSchemaPropertyFragment}
`;

export const LEASING_INCOME_SCHEMA_PARTNERS_SAVED = gql`
  subscription leasingIncomeSchemaXPartnersSaved {
    leasingIncomeSchemaXPartnersSaved {
      partners {
        ...leasingIncomeSchemaXPartner
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
  ${leasingIncomeSchemaXPartnerFragment}
`;

export const LEASING_INCOME_SCHEMA_DELETED = gql`
  subscription leasingIncomeSchemaDeleted {
    leasingIncomeSchemaDeleted {
      id
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;

export const LEASING_INCOME_SCHEMA_GROUPS_SAVED = gql`
  subscription leasingIncomeSchemaXGroupsSaved {
    leasingIncomeSchemaXGroupsSaved {
      groups {
        ...leasingIncomeSchemaXGroup
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
  ${leasingIncomeSchemaXGroupFragment}
`;
